import React, { useState, useEffect } from 'react';

function LapKinerja() {
  const [LapPasangData, setLapPasangData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);  
  const [searchQuery, setSearchQuery] = useState(''); 
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const schema = localStorage.getItem('schema');

  const today = new Date();
  const last30Days = new Date(today);
  last30Days.setDate(today.getDate() - 30);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date)) return '';
    return date.toISOString().split('T')[0];
  };

  const formatNumber = (value) => {
    if (isNaN(value)) return value;
    return new Intl.NumberFormat('id-ID', { minimumFractionDigits: 0 }).format(Number(value));
  };


  const [start_date, setStartDate] = useState(formatDate(last30Days));
  const [end_date, setEndDate] = useState(formatDate(today));

  const [filters, setFilters] = useState({
    TANGGAL: '',
    KD_KENDARAAN: '',
    NOPOL: '', 
  });

  const fetchLapPasangData = async () => {
    setLoading(true);
    setError(null);
    try {
      if (!start_date || !end_date) {
        throw new Error('Tanggal awal dan akhir harus diisi');
      }

      const url = `${process.env.REACT_APP_API_BASE_URL}/laporan.php?caller=lap_kinerja&schema=${schema}&start_date=${start_date}&end_date=${end_date}`;
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      if (Array.isArray(data)) {
        setLapPasangData(data);
        setFilteredData(data);
      } else {
        throw new Error('Invalid data format from API');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (start_date && end_date) {
      fetchLapPasangData();
    }
  }, [start_date, end_date]);

  useEffect(() => {
    applyFilters();
  }, [filters, LapPasangData]);

  const applyFilters = () => {
    let filtered = LapPasangData.filter((item) => 
      Object.keys(filters).every((key) =>
        filters[key] === '' || String(item[key]).toLowerCase().includes(filters[key].toLowerCase())
      )
    );
    setFilteredData(filtered);
  };

  const handleColumnFilter = (e, key) => {
    setFilters({ ...filters, [key]: e.target.value });
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });

    const sortedData = [...filteredData].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredData(sortedData);
  };

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'asc' ? '▲' : '▼';
    }
    return '';
  };


  const ImportData = async () => {
  setLoading(true);
  setError(null);
  try {
      const d = new Date(end_date);
      const tahun = d.getFullYear();
      const bulan = String(d.getMonth() + 1).padStart(2, '0');

      
      const url = `${process.env.REACT_APP_API_BASE_URL}/updatelokasi_bulanan.php?tahun=${tahun}&bulan=${bulan}`;
      const response = await fetch(url);
      if (!response.ok) {
      throw new Error('Network response was not ok');
      }

      const result = await response.json();

      if (result.status === "done") {
      alert(`✅ Import selesai.\nHapus: ${result.deleted_rows}, Insert: ${result.inserted}, Gagal: ${result.failed}`);
      await fetchLapPasangData();  
      } else {
      throw new Error('Proses import gagal');
      }
  } catch (err) {
      setError(err.message);
  } finally {
      setLoading(false);
  }
  };

  return (
    <div>
      <div className="section-header">
        <h2>KINERJA KENDARAAN</h2>
        <div className="responsive-filter">
          <label>Periode: </label>
          <input type="date" value={start_date} onChange={(e) => setStartDate(e.target.value)} />
          <input type="date" value={end_date} onChange={(e) => setEndDate(e.target.value)}/>
          <button onClick={fetchLapPasangData} disabled={loading}>
            {loading ? "Loading..." : "Refresh"}
          </button>
          <button onClick={ImportData} disabled={loading}>
            {loading ? "Processing..." : "Import"}
          </button>
        </div>
      </div>

      <div style={{ overflowX: 'auto', background: '#fff', borderRadius: '0 0 10px 10px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
        <table className="responsive-table">
          <thead>
            <tr>
              <th onClick={() => handleSort('KD_KENDARAAN')} style={{ cursor: 'pointer', width: '100px' }}>
                KD KENDARAAN {getSortIcon('KD_KENDARAAN')}
              </th>
              <th onClick={() => handleSort('TOTAL_KM')} style={{ cursor: 'pointer', width: '100px' }}>
                KILOMETER {getSortIcon('TOTAL_KM')}
              </th>
              <th onClick={() => handleSort('WKT_DRIVING')} style={{ cursor: 'pointer', width: '60px' }}>
                DRIVING (JAM) {getSortIcon('WKT_DRIVING')}
              </th>
              <th onClick={() => handleSort('WKT_IDLE')} style={{ cursor: 'pointer', width: '60px' }}>
                IDLE  (JAM) {getSortIcon('WKT_IDLE')}
              </th>
              <th onClick={() => handleSort('WKT_PARKIR')} style={{ cursor: 'pointer', width: '60px' }}>
                PARKIR (JAM) {getSortIcon('WKT_PARKIR')}
              </th>
            </tr>
            <tr>
              <th><input style={{ width: '80%' }} type="text" onChange={(e) => handleColumnFilter(e, 'KD_KENDARAAN')} placeholder="Filter..." /></th>
              <th><input style={{ width: '80%' }} type="text" onChange={(e) => handleColumnFilter(e, 'TOTAL_KM')} placeholder="Filter..." /></th>
              <th><input style={{ width: '80%' }} type="text" onChange={(e) => handleColumnFilter(e, 'WKT_DRIVING')} placeholder="Filter..." /></th>
              <th><input style={{ width: '80%' }} type="text" onChange={(e) => handleColumnFilter(e, 'WKT_IDLE')} placeholder="Filter..." /></th>
              <th><input style={{ width: '80%' }} type="text" onChange={(e) => handleColumnFilter(e, 'WKT_PARKIR')} placeholder="Filter..." /></th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((item) => (
                <tr key={item.ID}>
                  {['KD_KENDARAAN','TOTAL_KM', 'WKT_DRIVING', 'WKT_IDLE', 'WKT_PARKIR'].map((key) => (
                    <td
                      key={key}
                      style={{
                        textAlign: key === 'TOTAL_KM' || key === 'WKT_DRIVING' || key === 'WKT_IDLE' || key === 'WKT_PARKIR' ? 'center' : 'left'
                      }}
                    >
                      {key === 'TOTAL_KM' || key === 'WKT_DRIVING' || key === 'WKT_IDLE' || key === 'WKT_PARKIR' ? formatNumber(item[key]) : item[key]}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="11" style={{ textAlign: 'center', padding: '10px' }}>Tidak ada data</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default LapKinerja;
